import React, { useContext, useState, useEffect } from "react";
import { CustomButton } from "../CustomButton/CustomButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AppContext } from "../../store/AppContext";
import { Button } from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { getAuth, signOut } from "firebase/auth";

const Header = () => {
  const {
    headerData,
    isCollapsed,
    setIsCollapsed,
    isMobileSidebarOpen,
    setIsMobileSidebarOpen,
  } = useContext(AppContext);

  const [isMobile, setIsMobile] = useState(false);

  // Check screen size and update mobile state
  useEffect(() => {
    const checkScreenSize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleLogout = async () => {
    try {
      const auth = getAuth();
      await signOut(auth);
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const toggleSidebar = () => {
    if (isMobile) {
      setIsMobileSidebarOpen(!isMobileSidebarOpen);
    } else {
      setIsCollapsed(!isCollapsed);
    }
  };

  const getHeaderWidth = () => {
    if (isMobile) {
      return "100%";
    }
    return isCollapsed ? "calc(100% - 80px)" : "calc(100% - 250px)";
  };

  const getHeaderLeft = () => {
    if (isMobile) {
      return "0";
    }
    return isCollapsed ? "80px" : "250px";
  };

  return (
    <div
      style={{
        height: "8vh",
        minHeight: "60px",
        background: "#f4f4f4",
        position: "fixed",
        top: "0",
        width: getHeaderWidth(),
        left: getHeaderLeft(),
        right: "0",
        zIndex: "15",
        transition: "all 0.4s ease",
        borderBottom: "1px solid #e0e0e0",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          height: "100%",
          padding: "0 20px",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
            flex: 1,
          }}
        >
          {/* Menu Toggle Button */}
          <div
            onClick={toggleSidebar}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              padding: "8px",
              borderRadius: "6px",
              transition: "background-color 0.2s ease",
              backgroundColor: "transparent",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.04)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
            }}
          >
            {isMobile && isMobileSidebarOpen ? (
              <CloseIcon sx={{ color: "#666", fontSize: "24px" }} />
            ) : (
              <MenuIcon sx={{ color: "#666", fontSize: "24px" }} />
            )}
          </div>

          {/* Left Header Content */}
          {headerData?.leftText?.length > 0 && (
            <div
              style={{
                display: "flex",
                gap: "15px",
                alignItems: "center",
                flex: 1,
              }}
            >
              {!headerData?.back && (
                <ArrowBackIcon
                  style={{
                    cursor: "pointer",
                    color: "#666",
                    transition: "color 0.2s ease",
                  }}
                  onClick={() => {
                    headerData?.leftAction();
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = "#333";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = "#666";
                  }}
                />
              )}

              <h4
                style={{
                  fontSize: isMobile ? "1rem" : "1.1rem",
                  color: "#333",
                  fontWeight: "600",
                  margin: "0",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {headerData?.leftText}
              </h4>
            </div>
          )}
        </div>

        {/* Right Header Content */}
        <div
          style={{
            display: "flex",
            gap: isMobile ? "8px" : "10px",
            alignItems: "center",
            flexShrink: 0,
          }}
        >
          {headerData?.rightActionText?.length > 0 && (
            <>
              {headerData?.rightActionSecondaryText?.length > 0 && (
                <Button
                  onClick={() => {
                    headerData?.rightActionSecondary();
                  }}
                  color="error"
                  variant="outlined"
                  sx={{
                    minWidth: isMobile ? "auto" : "150px",
                    textTransform: "unset",
                    fontSize: isMobile ? "0.8rem" : "0.875rem",
                    padding: isMobile ? "6px 12px" : "6px 16px",
                  }}
                >
                  {isMobile
                    ? headerData?.rightActionSecondaryText?.substring(0, 8) +
                      "..."
                    : headerData?.rightActionSecondaryText}
                </Button>
              )}
              <CustomButton
                sx={{
                  textTransform: "none",
                  fontSize: isMobile ? "0.8rem" : "0.875rem",
                  padding: isMobile ? "6px 12px" : "6px 16px",
                  minWidth: isMobile ? "auto" : "unset",
                }}
                variant="contained"
                onClick={() => {
                  headerData?.rightAction();
                }}
              >
                {isMobile && headerData?.rightActionText?.length > 10
                  ? headerData?.rightActionText?.substring(0, 8) + "..."
                  : headerData?.rightActionText}
              </CustomButton>
            </>
          )}

          {/* Optional Logout Button in Header */}
          {!isMobile && (
            <Button
              color="inherit"
              onClick={handleLogout}
              startIcon={<ExitToAppIcon />}
              sx={{
                textTransform: "none",
                color: "#666",
                display:
                  headerData?.rightActionText?.length > 0 ? "none" : "flex",
                "&:hover": {
                  color: "#333",
                  backgroundColor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              Sign Out
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
